export function calculateReadTime(text) {
    const wordsPerMinute = 200;
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / wordsPerMinute);
}

export function toFarsiNumber(input) {
    const farsiDigits = '۰۱۲۳۴۵۶۷۸۹';
    return String(input).replace(/\d/g, (d) => farsiDigits[d]);
}

export const handleCopyToClipboard = (text) => {

    if (!navigator.clipboard) {
        // Fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed"; // Avoid scrolling to bottom
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            document.execCommand("copy");
        } catch (err) {
            console.error("Failed to copy (fallback)", err);
        }
        document.body.removeChild(textarea);
        return;
    }

    navigator.clipboard.writeText(text)
        .then(() => {
            // Optionally show a toast: toast.success("Copied!");
        })
        .catch((err) => {
            console.error("Failed to copy!", err);
        });
};
